import { ReactNode } from "react"

export type NpUppercaseHeadingProps = {
  as: "h2" | "h3" | "p"
  children: ReactNode
}

export const NpUppercaseHeading = ({ as, children }: NpUppercaseHeadingProps) => {
  const H = as

  return <H className="text-h4-np m-0 text-center hyphens-none uppercase">{children}</H>
}
